import React from 'react';
import { Send, FileText, RefreshCw } from 'lucide-react';
import { Button } from '../../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';

const ComposeEmailCard = ({
  emailRecipients,
  savedLists,
  selectedRecipientType,
  setSelectedRecipientType,
  customEmails,
  setCustomEmails,
  emailSubject,
  setEmailSubject,
  emailContent,
  setEmailContent,
  scheduleEnabled,
  setScheduleEnabled,
  scheduleAt,
  setScheduleAt,
  emailLoading,
  onSend,
  onSaveCurrentAsTemplate,
}) => {
  const isComposerEmpty = !emailSubject.trim() || !emailContent.trim();

  return (
    <Card className="email-compose-card">
      <CardHeader>
        <CardTitle className="email-card-title">
          <Send size={20} />
          Compose Email
        </CardTitle>
      </CardHeader>
      <CardContent>
        {/* Recipient Selection */}
        <div className="email-field">
          <label>Send To:</label>
          <select
            value={selectedRecipientType}
            onChange={(e) => setSelectedRecipientType(e.target.value)}
            className="email-select"
            data-testid="recipient-type-select"
          >
            <option value="all">All Contacts ({emailRecipients?.all_unique_count || 0})</option>
            <option value="ota">OTA Signups ({emailRecipients?.ota_count || 0})</option>
            <option value="contacts">Contact Form Submissions ({emailRecipients?.contacts_count || 0})</option>
            <option value="custom">Custom Email List (paste below)</option>
            {savedLists.length > 0 && (
              <optgroup label="Saved Lists">
                {savedLists.map((list) => (
                  <option key={list.id} value={`list:${list.id}`}>
                    {list.name} ({list.count})
                  </option>
                ))}
              </optgroup>
            )}
          </select>
        </div>

        {selectedRecipientType === 'custom' && (
          <div className="email-field">
            <label>Enter Emails (comma or line separated):</label>
            <textarea
              value={customEmails}
              onChange={(e) => setCustomEmails(e.target.value)}
              placeholder="email1@example.com, email2@example.com; email3@example.com"
              className="email-textarea custom-emails"
              rows={3}
            />
          </div>
        )}

        <div className="email-field">
          <label>Subject:</label>
          <input
            type="text"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
            placeholder="Enter email subject"
            className="email-input"
          />
        </div>

        <div className="email-field">
          <label>Message (HTML supported):</label>
          <textarea
            value={emailContent}
            onChange={(e) => setEmailContent(e.target.value)}
            placeholder="Enter your message..."
            className="email-textarea"
            rows={10}
          />
        </div>

        {/* Schedule toggle */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
          <label style={{ color: '#fff', fontSize: '0.9rem', display: 'flex', alignItems: 'center', gap: '0.4rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={scheduleEnabled}
              onChange={(e) => setScheduleEnabled(e.target.checked)}
              data-testid="schedule-toggle"
              style={{ accentColor: '#FFD700' }}
            />
            Schedule for later
          </label>
          {scheduleEnabled && (
            <input
              type="datetime-local"
              value={scheduleAt}
              onChange={(e) => setScheduleAt(e.target.value)}
              data-testid="schedule-datetime"
              min={new Date(Date.now() + 60000).toISOString().slice(0, 16)}
              className="email-input"
              style={{ flex: 1, minWidth: '180px' }}
            />
          )}
        </div>

        <Button
          onClick={onSend}
          className="send-email-btn"
          disabled={emailLoading || isComposerEmpty}
          data-testid="send-email-btn"
        >
          {emailLoading ? (
            <>
              <RefreshCw size={18} className="animate-spin" />
              {scheduleEnabled ? 'Scheduling...' : 'Sending...'}
            </>
          ) : (
            <>
              <Send size={18} />
              {scheduleEnabled ? 'Schedule Email' : 'Send Email'}
            </>
          )}
        </Button>

        <Button
          type="button"
          onClick={onSaveCurrentAsTemplate}
          variant="outline"
          data-testid="save-draft-as-template-btn"
          disabled={isComposerEmpty}
          style={{
            marginTop: '0.75rem',
            width: '100%',
            background: 'transparent',
            border: '1px solid rgba(255,215,0,0.4)',
            color: '#FFD700',
          }}
        >
          <FileText size={16} style={{ marginRight: 6 }} />
          Save as Template
        </Button>
      </CardContent>
    </Card>
  );
};

export default ComposeEmailCard;
